<template>
    <div>
        <div class="card bg-base-100 flex flex-col md:flex-row">
            <div class="w-full md:w-2/3">
                <div v-if="order.CP_STATUS == 'wait_set_custom_requisite'">
                    <div class="flex justify-center mb-4">
                        <h4 class="text-center text-xl text-neutral">{{ loadingTexts[currentTextIndex] }}</h4>
                    </div>
                    <h4 class="text-center mt-1 text-neutral-content">
                        {{ $t("orderPage.counterPartyPayment.waitCustomRequisiteSubtitle") }}
                    </h4>
                    <div class="flex justify-center items-center mt-2">
                        <div class="text-primary">
                            <Icon icon="eos-icons:loading" height="60" />
                        </div>
                    </div>
                </div>
                <div v-if="order.CP_STATUS == 'wait_payment'">
                    <div class="flex justify-center mb-4">
                        <h4 class="text-center text-xl text-neutral">
                            {{ $t("orderPage.counterPartyPayment.waitPaymentTitle") }}
                        </h4>
                    </div>
                    <h4 class="text-center mt-1 text-neutral-content">
                        {{ $t("orderPage.counterPartyPayment.waitPaymentSubtitle", { minutes: waitPaymentMinutes }) }}
                    </h4>

                    <div class="flex flex-col md:flex-row justify-center  mt-4">
                        <div class="w-full md:w-1/2 py-2">
                            <StepItem :number="1" :text="$t('orderPage.counterPartyPayment.step1')" />
                            <div class="my-4">
                                <p class="text-sm text-neutral-content">{{ $t("orderPage.payment.sum") + ":" }}</p>
                                <div class="flex items-center gap-2">
                                    <span class="text-lg text-neutral"
                                        >{{ new Intl.NumberFormat("ru-RU").format(paymentSum) }} <span class="text-sm text-neutral-content">{{ takeCurrency }}</span>
                                    </span>
                                    <CopyBoard title="Sum" iconName="tabler:copy" classes="ml-1" :text="paymentSum" />
                                </div>
                            </div>
                            <Fields :fields="order.CP_FIELDS" />
                        </div>
                        <div class="w-full md:w-1/2 py-2">
                            <StepItem class="mb-4" :number="2" :text="$t('orderPage.counterPartyPayment.step2')" />
                            <p class="text-neutral-content">
                                {{ $t("orderPage.counterPartyPayment.step2desc") }} <br />
                                <a class="text-primary" :href="`mailto:${EMAIL_FOR_SEND_CHECK}`">{{ EMAIL_FOR_SEND_CHECK }}</a>
                            </p>
                            <div class="flex justify-center items-center mt-4">
                                <img src="../../../assets/check-example.jpg" class="w-60" />
                            </div>
                            <!-- <div class="flex flex-col items-center justify-center mt-4">
                            <UploadCheck @file-changed="handleFileChanged" />
                        </div> -->
                            <!-- <StepItem :number="1" :text="$t('orderPage.counterPartyPayment.waitPaymentTitle')" -->
                            <my-button class="mt-4 w-full" variant="primary" :value="$t('popupOrder.paymentOrder.action.iPaid')" @click.native="paymentHandler" :spinner="spinner"></my-button>
                        </div>
                    </div>
                </div>
                <div v-if="order.CP_STATUS == 'check_payment'">
                    <div class="flex justify-center mb-4">
                        <h4 class="text-center text-xl text-neutral">
                            {{ $t("orderPage.counterPartyPayment.checkPaymentTitle") }}
                        </h4>
                    </div>
                    <h4 class="text-center mt-1 text-neutral-content">
                        {{ $t("orderPage.counterPartyPayment.checkPaymentSubtitle") }}
                    </h4>
                    <div class="flex justify-center items-center mt-2">
                        <div class="text-primary">
                            <Icon icon="eos-icons:loading" height="60" />
                        </div>
                    </div>
                </div>
            </div>

            <div class="text-center  w-full md:w-1/3">
                <p class="text-lg text-neutral mb-4">
                    {{ $t("notification.order.counterpartyReceive.title") }}
                </p>
                <p
                    class="text-sm text-error"
                    v-html="
                        this.$t('notification.createOrder.counterpartyReceive.rules', {
                            email: EMAIL_FOR_SEND_CHECK
                        })
                    "
                ></p>
            </div>
        </div>
    </div>
</template>

<script>
import { Icon } from "@iconify/vue2";
import CopyBoard from "../../../components/ui/CopyBoard.vue";
import Fields from "./Payment/Fields.vue";
// import UploadCheck from "../UI/UploadCheck.vue";

import MyButton from "../../../components/ui/button.vue";
import StepItem from "../../../components/ui/StepItem.vue";

import OrderService from "../../../services/OrderService";
import { mapGetters } from "vuex";
import { EMAIL_FOR_SEND_CHECK } from "../../../config";

export default {
    props: {
        order: {
            type: Object,
            required: true
        }
    },
    components: {
        Icon,
        CopyBoard,
        Fields,
        // UploadCheck,
        MyButton,
        StepItem
    },
    data() {
        return {
            EMAIL_FOR_SEND_CHECK,
            checkFile: null,
            spinner: false,
            currentTextIndex: 0,
            textRotationInterval: 10000,
            loadingTexts: [this.$t("orderPage.counterPartyPayment.waitCustomRequisiteTitle1"), this.$t("orderPage.counterPartyPayment.waitCustomRequisiteTitle2"), this.$t("orderPage.counterPartyPayment.waitCustomRequisiteTitle3")]
        };
    },
    mounted() {
        this.startTextRotation();
    },
    beforeDestroy() {
        if (this.textRotationInterval) {
            clearInterval(this.textRotationInterval);
        }
    },
    methods: {
        startTextRotation() {
            this.textRotationInterval = setInterval(() => {
                if (this.currentTextIndex < this.loadingTexts.length - 1) {
                    this.currentTextIndex++;
                } else {
                    clearInterval(this.textRotationInterval);
                }
            }, this.textRotationInterval);
        },
        handleFileChanged(file) {
            this.checkFile = file;
        },
        paymentHandler() {
            // if (!this.checkFile) return;
            if (this.spinner) return;
            this.spinner = true;
            let form = new FormData();
            // form.append("check", this.checkFile);
            form.append("hash", this.order.hash);
            OrderService.uploadCheck(form, this.order.hash)
                .then(() => {
                    // this.successHandler(data);
                })
                .finally(() => {
                    this.spinner = false;
                });
            // let form = new FormData();
            //     form.append("data", JSON.stringify(this.orderData));
            //     form.append("dest", "card");
            //     form.append("image", this.file);
            //     let response = await OrderService.create(form);
            //     this.successHandler(response.data);
            // axios
            //     .post("/file/upload", form)
            //     .then(({ data }) => {
            //         let filename = data.filename;
            //         this.setHandler(filename);
            //     })
            //     .catch(e => {
            //         let message = e?.response?.data?.message;
            //         if (message) {
            //             this.SET_SNACK_BAR({ active: true, text: message });
            //         }
            //     })
            //     .finally(() => {
            //         this.uploading = false;
            //     });
        }
    },
    computed: {
        ...mapGetters(["getConfig"]),
        takeCurrencyName() {
            return this?.order?.currency?.take?.name || "-";
        },
        paymentSum() {
            return this.order.amount.take;
        },
        waitPaymentMinutes() {
            return this.getConfig?.ORDER_COUNTERPARTY_STATUS?.WAIT_PAYMENT?.expire_minutes || "-";
        }
    }
};
</script>
